// extracted by mini-css-extract-plugin
export var fileExt = "_sb-8";
export var fileIcon = "_sb-6";
export var fileLink = "_sb-5";
export var fileName = "_sb-7";
export var image = "_sb-1";
export var imageError = "_sb-3";
export var imageErrorIcon = "_sb-4";
export var imageLink = "_sb-0";
export var imageLoaded = "_sb-2";